export function mailto({
  to = "support@winamp.com",
  subject,
  body,
  cc,
  bcc,
}: {
  to?: string | Array<string>;
  subject: string;
  body: string | Array<string>;
  cc?: string | Array<string>;
  bcc?: string | Array<string>;
}) {
  const mailtoParams = [
    `subject=${encodeURIComponent(subject)}`,
    `body=${encodeURIComponent(Array.isArray(body) ? body.join("\n") : body)}`,
    cc && `cc=${encodeURIComponent(Array.isArray(cc) ? cc.join(",") : cc)}`,
    bcc &&
      `bcc=${encodeURIComponent(Array.isArray(bcc) ? bcc.join(",") : bcc)}`,
  ]
    .filter(Boolean)
    .join("&");

  return `mailto:${Array.isArray(to) ? to.join(",") : to}?${mailtoParams}`;
}
